import React from "react";
import MenuLayout from "../../components/MenuLayout/MenuLayout";
import Button from "../../components/Button/Button";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";
const HoppersCafeMenuPage = ({ components }) => {
    const dispatch = useDispatch()
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersCafeMenuPage-header":
                return <div className="HoppersCafeMenuPage-header">{component?.Props?.text}</div>
            case "HoppersCafeMenuPage-subheader":
                return <div className="HoppersCafeMenuPage-subheader">{component?.Props?.text}</div>
            case "HoppersCafeMenuPage-menu":
                return <div className="HoppersCafeMenuPage-grid">
                    {component?.Data?.map((data, key) => {
                        return (
                            <MenuLayout
                                data={data}
                                key={key} />
                        )
                    })}
                </div>
            case "HoppersCafeMenuPage-button":
                return <div className="HoppersCafeMenuPage-btncont">
                    <Button
                        text={component?.Props?.btnText}
                        width={component?.Props?.width}
                        onClick={() => {
                            if (component?.Props?.href && component?.Props?.href?.includes("https://")) {
                                window.open(component?.Props?.href, '_blank')
                            } else {
                                dispatch(setIsComing(true))
                            }
                        }}
                    />
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="HoppersCafeMenuPage">
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div>
    )
}
export default HoppersCafeMenuPage